module.exports = __webpack_public_path__ + "static/img/3.65420f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cs/3.jpg
// module id = BiQQ
// module chunks = 1